import { ReactNode } from 'react'
import { Box, IconArrowRight, Text, TextLinkButton } from '@machobear/design-system'

interface Props {
  title: string
  description: string
  icon: ReactNode
  linkText: string
  onClick: () => void
}

export const RecommendationBlock = ({ title, description, icon, linkText, onClick }: Props) => (
  <Box
    padding="gutter"
    gap="gutter"
    background="surface"
    border="borderNeutralLight"
    borderRadius="standard"
    display="flex"
    flexDirection="column"
    alignItems="flexStart"
    style={{ flex: 1, minWidth: '225px' }}
  >
    <Box
      style={{ width: '28px', height: '28px' }}
      background="message"
      display="flex"
      alignItems="center"
      justifyContent="center"
      borderRadius="small"
      padding="xxxsmall"
    >
      {icon}
    </Box>

    <Box gap="small" display="flex" flexDirection="column">
      <Text size="standard" weight="strong">
        {title}
      </Text>
      <Text size="small">{description}</Text>
    </Box>

    <Text>
      <TextLinkButton
        onClick={onClick}
        icon={<IconArrowRight tone="link" />}
        iconPosition="trailing"
      >
        {linkText}
      </TextLinkButton>
    </Text>
  </Box>
)
